<template>
  <v-container fluid>
    <v-tabs
      v-model="currentTab"
      color="transparent"
      fixed-tabs
      slider-color="primary"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.key"
        :href="'#tab-' + tab.key"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-dialog v-model="addDeviceDialog">
      <v-card>
        <v-container class="text-xs-center">
          <v-layout row wrap>
            <v-flex xs6>
              <v-select outline class="ml-2" v-model="selectedDeviceType" label="Device Type" :items="filteredDeviceTypes" item-text="name" return-object item-value="id"></v-select>
            </v-flex>
            <template v-if="selectedDeviceType !== null">
              <template v-for="item in selectedDeviceType.extras">
                <v-flex xs6>
                  <v-text-field outline class="ml-2" v-if="['text', 'number'].indexOf(item.type) !== -1" v-model="newDevice[item.name]" :type="item.type === 'number' ? 'number' : 'text'" :step="item.type === 'number' ? item.step : ''" :label="item.name" />  
                  <v-text-field outline class="ml-2" :readonly="editID !== -1" v-if="item.type === 'uid'" :rules="[v => deviceIDs.indexOf(v) === -1 || v === editID || 'Device already in system']" v-model="newDevice[item.name]" :label="item.name" />  
                  <v-autocomplete outline class="ml-2" clearable v-if="item.type === 'sim'" item-text="ICCID" item-value="ICCID" :rules="[v => filteredSIMS.indexOf(v) === -1 || v === editSIM || 'SIM already allocated to another device']" :items="SIMS" v-model="newDevice[item.name]" :label="item.name" />  
                  <v-select outline class="ml-2" v-model="newDevice[item.name]" v-if="item.type === 'choice'" :label="item.name" :items="item.options" :value="item.default" clearable />  
                </v-flex>
              </template>
              <v-flex xs6>
                <v-autocomplete outline class="ml-2" clearable label="Customer" v-model="newDevice.customer" :items="customers" item-text="name" item-value="key" />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outline class="ml-2" clearable label="Vehicle Reg" v-model="newDevice.vehicle" :items="filteredVehicles" item-text="VehicleReg" item-value="key" />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outline class="ml-2" clearable label="Product" v-model="newDevice.product" :items="filteredProducts" item-text="name" item-value="id" />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete outline class="ml-2" label="Stock Location" v-model="newDevice.stockLocation" :items="stockChoices" />
              </v-flex>
            </template>
          </v-layout>
          <v-btn @click="addDevice" color="primary" :loading="adding" v-html="editID === -1 ? 'Add Device' : 'Edit Device'"></v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkAddDeviceDialog">
      <v-card>
        <v-container class="text-xs-center">
          <v-select v-model="selectedDeviceType" label="Device Type" :items="filteredDeviceTypes" item-text="name" return-object item-value="id" :disabled="exported"></v-select>
          <v-autocomplete clearable label="Product" v-model="exportProduct" :items="filteredProducts" item-text="name" item-value="id" :disabled="exported"/>
          <template v-if="selectedDeviceType">
            <v-btn
              v-if="exported"
              color="primary"
              dark
              @click="exported = false; excelInput = ''; dataProcessed = false"
            >
              Reset
            </v-btn>
            <template v-if="exported">
              <div>
                <v-alert
                  v-model="exported"
                  dismissible
                  type="success"
                >
                  Data Exported To Clipboard Successfully. Please make any alterations and paste data into below textbox to process.
                </v-alert>
              </div>
            </template>
            <v-btn v-if="!exported" @click="createExportTemplate" color="primary">Export Template</v-btn>
            <v-textarea label="Warning - Only the first 500 rows will be processed" id="excelInput" v-model="excelInput"></v-textarea>
            <v-btn @click="importFromTemplate" color="primary">Import</v-btn>
          </template>
        </v-container>
      </v-card>
    </v-dialog>
    <v-tabs-items v-model="currentTab">
      <v-tab-item
        key="devices"
        value="tab-devices"
      >
        <v-card flat>
          <v-card-title>
              <v-flex xs6>
                <v-card class="pa-2 ma-1 text-xs-center">
                  <v-progress-circular :size="70" :width="10" :rotate="360" :value="(stockTotal / filteredDevices.length) * 100" color="primary">
                    {{stockTotal}}
                  </v-progress-circular>
                  <div class="title">Unallocated Stock</div>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card class="pa-2 ma-1 text-xs-center">
                  <v-progress-circular :size="70" :width="10" :rotate="360" :value="((filteredDevices.length - stockTotal) / filteredDevices.length) * 100" color="green">
                    {{filteredDevices.length - stockTotal}}
                  </v-progress-circular>
                  <div class="title">Allocated Devices</div>
                </v-card>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                  <v-autocomplete
                    :items="filteredDeviceTypes"
                    v-model="deviceTypeFilter"
                    label="Filter Device Type"
                    item-text="name"
                    item-value="id"
                    clearable
                    solo
                  >
                  </v-autocomplete>
                  <v-spacer></v-spacer>
                  <v-autocomplete
                    :items="filteredVehicles"
                    v-model="vehicleFilter"
                    label="Filter Vehicle"
                    item-text="VehicleReg"
                    item-value="key"
                    multiple
                    hide-detaile
                    chips
                    deletable-chips
                    clearable
                    solo
                  >
                  </v-autocomplete>
                  <v-spacer></v-spacer>
                  <v-autocomplete
                    clearable
                    v-model="selectedCustomer"
                    label="Select Customer"
                    :items="customers"
                    item-text="name"
                    item-value="key"
                    multiple
                    chips
                    dense
                    deletable-chips
                    solo
                  >
                  </v-autocomplete>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-alert
                    v-model="exportAlert"
                    type="success"
                    dismissible
                  >
                    Data copied to clipboard
                  </v-alert>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-btn color="primary" @click="newDeviceDialog">
                      Add Devices
                    </v-btn>
                    <v-btn color="primary" @click="bulkAddDeviceDialog = true">
                      Bulk Import
                    </v-btn>
                    <v-btn color="primary" @click="exportData">Export</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="deviceSearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-layout>
                </v-flex>
            </v-layout>
          </v-card-title>
          <v-data-table :rows-per-page-items="[5, 10, 25, 50, 100, 200, {'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]" v-if="filteredDevices" :loading="devicesLoading" :search="deviceSearch" :items="filteredDevices" :headers="deviceColumns">
            <template slot="items" slot-scope="props">
              <tr>
                <td @click.stop="getDeviceHistory(props)">{{props.item.id}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.formattedType}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.IMEI}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.formattedCustomer}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.formattedVehicle}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.formattedProduct}}</td>
                <td @click.stop="getDeviceHistory(props)" :class="props.item.SIM === null || props.item.SIM.length < 19 ? 'error' : ''">{{props.item.SIM}}</td>
                <td @click.stop="getDeviceHistory(props)">{{props.item.stockLocation}}</td>
                <td>
                  <v-btn flat icon small @click="openTesting(props.item)"><v-icon>mdi-cloud-check</v-icon></v-btn>
                  <v-btn color="primary" flat icon small @click="editDevice(props.item)"><v-icon>edit</v-icon></v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-layout justify-center>
                <v-card flat v-if="installationJob">
                  <ul style="list-style-type: none;">
                    <li>Contract Start: {{installationJob.CompletedDate}}</li>
                    <li>Contract Term: {{installationJob.contractDetails.length}} {{installationJob.contractDetails.period}}</li>
                    <li>Contract Expiry: {{installationJob.contractDetails.expiry}}</li>
                    <li>Warranty Period: {{installationJob.finance[props.item.type].warranty}}</li>
                    <li>Warranty Type: {{installationJob.finance[props.item.type].warrantyType}}</li>
                    <li>Upfront Amount: {{installationJob.finance[props.item.type].upfrontPayment}}</li>
                    <li>Upfront Installation: {{installationJob.finance[props.item.type].installationPayment}}</li>
                    <li>Rental Frequency: {{installationJob.finance[props.item.type].rentalFrequency}}</li>
                    <li>Rental Amount: {{installationJob.finance[props.item.type].rentalPayment}}</li>
                    <li>Lease Frequency: {{installationJob.finance[props.item.type].leaseFrequency}}</li>
                    <li>Lease Amount: {{installationJob.finance[props.item.type].leasePayment}}</li>
                    <li>Installation Date: {{installationJob.CompletedDate}}</li>
                    <li>Project: {{installationJob.Project}}</li>
                    <li>View Job: <v-btn small :to="{path: `/Project/${installationJob.Customer}/${installationJob.id}`}" flat>{{installationJob.JobNo}}</v-btn></li>
                    <li>View Product: <v-btn small :to="{path: `/Products/${installationJob.Customer}/${props.item.product}/${props.item.vehicle}`}" flat>Go To Product</v-btn></li>
                  </ul>
                </v-card>
                <v-card flat v-else-if="!loadingDeviceHistory">
                  <v-card-title>No Installation Details Found</v-card-title>
                </v-card>
                <v-card flat v-else>
                  <v-card-title>Loading...</v-card-title>
                </v-card>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab-item
        key="calamp"
        value="tab-calamp"
      >
        <v-layout row wrap>
          <v-flex sm2>
            <v-switch
              v-model="bulk"
              label="Bulk Paste"
              color="primary"
            ></v-switch>
          </v-flex>
          <v-flex sm2>
            <v-switch
              v-model="useIMEI"
              label="Use IMEI"
              color="primary"
            ></v-switch>
          </v-flex>
        </v-layout>
        <v-textarea :label="`Bulk Paste ${useIMEI ? 'IMEI' : 'ESN'}'s Here`" @keydown.prevent @input="updateESN" v-model="inputESN" v-if="bulk"/>
        <v-combobox
          v-if="!bulk"
          v-model="ESNarray"
          chips
          deletable-chips
          :label="`Input ${useIMEI ? 'IMEI' : 'ESN'} and press enter`"
          type="number"
          multiple
          outline
        ></v-combobox>
        <v-flex xs12 text-xs-center>
          <v-btn
            @click="lookupCalamp"
            color="primary"
            :disabled="!ESNarray.length"
          >
            Lookup Calamps
          </v-btn>
          <v-btn :disabled="!selectedEsns.length" @click="initUpdateDialog" color="secondary">
            Update Selected
          </v-btn>
          <v-btn :disabled="!selectedEsns.length" @click="gotoBulkSMS">
            Populate Bulk SMS
          </v-btn>
        </v-flex>
        <v-dialog max-width="600px" v-model="updateCalampDialog">
          <v-card>
            <v-card-title>
              <span class="headline">Update Selected Calamps</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-checkbox
                      label="Update Config"
                      v-model="updateCalampObj.updateConfig"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :disabled="!updateCalampObj.updateConfig"
                      v-model="updateCalampObj.newConfig"
                      :items="calampConfigs"
                      label="New Config"
                      item-text="name"
                      return-object
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title>{{data.item.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{data.item.description}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      label="Update Group"
                      v-model="updateCalampObj.updateGroup"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :disabled="!updateCalampObj.updateGroup"
                      v-model="updateCalampObj.newGroup"
                      label="New Group"
                      :items="calampGroups"
                      item-text="name"
                      item-value="name"
                      return-object
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="updateCalampDialog = false">Close</v-btn>
              <v-btn color="success darken-1" flat @click="updateSelectedCalamps" :loading="updatingCalamps" :disabled="!updateCalampObj.updateGroup && !updateCalampObj.updateConfig">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
          :headers="calampHeaders"
          :items="filteredCalampTableDetails"
          class="elevation-1"
          item-key="esn"
          select-all
          v-model="selectedEsns"
          :pagination.sync="calampPagination"
        >
          <template slot="headerCell" slot-scope="props">
              {{ props.header.text }}
              <v-menu :key="props.header.index" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small :color="filters[props.header.index] && filters[props.header.index].length ? 'red' : ''">
                      mdi-filter-variant
                  </v-icon>
                  </v-btn>
              </template>
              <div style="background-color: white; width: 280px">
                  <v-list>
                  <v-list-tile>
                      <v-autocomplete multiple dense clearable chips small-chips color="light-blue lighten-3" :items="columnValueList(props.header.value)" append-icon="mdi-filter" v-model="filters[props.header.index]" :label="`Filter By: ${props.header.text}`
                      " hide-details>
                          <template v-slot:selection="{ item, index }">
                          <v-chip small class="caption" v-if="index < 5">
                              <span>
                              {{ item }}
                              </span>
                          </v-chip>
                          <span v-if="index === 5" class="grey--text caption">
                              (+{{ filters[index].length - 5 }} others)
                          </span>
                          </template>
                      </v-autocomplete>
                  </v-list-tile>
                  </v-list>
              </div>
              </v-menu>
          </template>
          <template v-slot:items="props">
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td @click="expandCalampDetails(props)">{{ props.item.esn }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.imei }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.group }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.configVersion }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.scriptVersion }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.configStatus }}</td>
            <td @click="expandCalampDetails(props)">{{ props.item.configGroup }}</td>
          </template>
          <template v-slot:expand="props">
            <v-card>
              <v-sheet class="pa-3 primary lighten-2">
                <v-text-field
                  v-model="searchCalamp"
                  label="Search Calamp Details"
                  dark
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  clear-icon="mdi-close-circle-outline"
                ></v-text-field>
              </v-sheet>
              <v-card-text
                style="overflow:auto; height:300px;"
              >
                <v-treeview
                  :items="activeCalampDetails"
                  :search="searchCalamp"
                >
                </v-treeview>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    <textarea id="exportData" hidden></textarea>
    <v-dialog v-model="testingDialog" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="testingDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Testing</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="testingDialog = false">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <testing :testID="testID" :testType="testType" :UID="testsUID"/>
      </v-card>
    </v-dialog>
    <v-dialog v-model="messagesDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">The API returned the following messages</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <ul v-for="(message, i) in updateCalampErrorMessages" :key="i">
              <li>{{message}}</li>
            </ul>
            <ul v-for="(message, i) in calampErrorMessages" :key="i">
              <li>{{message}}</li>
            </ul>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat="flat" @click="messagesDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Retrieving Data From Calamp
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { updateAuditLog, fireStore } from '../firebase'
import moment from 'moment'
export default {
  beforeRouteLeave (to, from, next) {
    if (this.selectedEsns.length > 0) {
      const answer = window.confirm('Do you really want to leave this page?.')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  props: ['customer', 'vehicle'],
  data () {
    return {
      active: null,
      addDeviceDialog: false,
      adding: false,
      bulkAddDeviceDialog: false,
      filters: [],
      calampHeaders: [
        { index: 0, text: 'ESN', value: 'esn' },
        { index: 1, text: 'IMEI', value: 'imei' },
        { index: 2, text: 'Group', value: 'group' },
        { index: 3, text: 'Config Version', value: 'configVersion' },
        { index: 4, text: 'Script Version', value: 'scriptVersion' },
        { index: 5, text: 'Config Status', value: 'configStatus' },
        { index: 6, text: 'Config Group', value: 'configGroup' }
      ],
      calampTableDetails: [],
      devicesLoading: false,
      deviceSearch: '',
      deviceTypeFilter: null,
      vehicleFilter: this.vehicle ? [this.vehicle] : [],
      loadingDeviceHistory: false,
      calampESN: '',
      calampGroups: [],
      calampConfigs: [],
      calampPagination: {
        descending: true,
        rowsPerPage: -1
      },
      editID: -1,
      editSIM: -1,
      inputESN: '',
      ESNarray: [],
      bulk: true,
      exported: false,
      exportProduct: null,
      exportAlert: false,
      excelInput: '',
      loadingDialog: false,
      calampErrorMessages: [],
      updateCalampErrorMessages: [],
      selectedEsns: [],
      stockTotal: 0,
      stockChoices: [
        'New Stock',
        'Service Stock',
        'Stock Return',
        'Customer Premises',
        'Van - Audio Advice',
        'Van - MJS',
        'Van - NW Installs',
        'Van - Ultimate Installations',
        'Van - Mobile Valley',
        'Van - GMN Electronics',
        'Installed'
      ],
      selectedCustomer: this.customer ? [this.customer] : [null],
      selectedDeviceType: {},
      testingDialog: false,
      installationJob: null,
      messagesDialog: false,
      newDevice: {
        customer: null,
        vehicle: null,
        stockLocation: 'new'
      },
      deviceColumns: [
        {text: 'Serial Number', value: 'id'},
        {text: 'Device Type', value: 'formattedDevice'},
        {text: 'IMEI', value: 'IMEI'},
        {text: 'Customer', value: 'formattedCustomer'},
        {text: 'Veh Reg', value: 'formattedVehicle'},
        {text: 'Product', value: 'formattedProduct'},
        {text: 'Sim Number', value: 'SIM'},
        {text: 'Stock Location', value: 'stockLocation'},
        {text: '', value: 'id', sortable: false}
      ],
      testsUID: null,
      testType: null,
      testID: null,
      tabs: [{key: 'devices', name: 'Devices'}, {key: 'calamp', name: 'Calamp API'}],
      updateCalampDialog: false,
      updateCalampObj: {
        updateConfig: false,
        updateGroup: false,
        newGroup: '',
        newConfig: ''
      },
      updatingCalamps: false,
      useIMEI: true,
      currentTab: 'tab-devices',
      calampDetails: [],
      searchCalamp: null,
      confirmedESNArray: [],
      authToken: null
    }
  },
  watch: {
    currentTab (val) {
      if (val === 'tab-calamp') {
        this.loadingDialog = true
        fetch('https://cwelite.aquariusit.com/calampMiddleManGetToken.php',
          {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((response) => {
          return response.json()
        })
        .then((token) => {
          this.authToken = token.authToken
          this.loadingDialog = false
        })
        .catch(error => alert(error))
      }
    },
    selectedDeviceType (val) {
      if (this.editID === -1) {
        this.newDevice = {
          customer: this.newDevice.customer,
          vehicle: this.newDevice.vehicle,
          type: val.id,
          stockLocation: 'new'
        }
        if (val && val.extras) {
          for (let extra of val.extras) {
            this.newDevice[extra.name] = extra.default || null
          }
        }
      }
    },
    'newDevice.vehicle' (val) {
      if (val) {
        this.newDevice.customer = this.vehicles.find(vehicle => { return val === vehicle.key }).Customer
      }
    }
  },
  created () {
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchDevices')
    this.$store.dispatch('fetchDeviceTypes')
    this.$store.dispatch('fetchProductTypes')
    this.$store.dispatch('fetchVehicles')
    this.$store.dispatch('fetchSIMS')
  },
  computed: {
    filteredCalampTableDetails () {
      let filteredCalampTableDetails = []
      let filters = this.filters
      for (let calamp of this.calampTableDetails) {
        let toAdd = true
        for (let i in filters) {
          if (filters[i] && filters[i].length && (filters[i].indexOf(calamp[this.calampHeaders[i].value]) === -1)) {
            if (filters[i].includes('') && !calamp[this.calampHeaders[i].value]) {
              toAdd = true
            } else {
              toAdd = false
              continue
            }
          }
        }
        if (toAdd) {
          filteredCalampTableDetails.push(calamp)
        }
      }
      return filteredCalampTableDetails
    },
    user () {
      return this.$store.getters.userData
    },
    customers () {
      let customers = [...this.$store.getters.customers]
      customers.unshift({name: 'Unallocated Stock', key: null})
      return customers
    },
    deviceTypes () {
      return this.$store.getters.deviceTypes
    },
    devices () {
      return this.$store.getters.devices
    },
    productTypes () {
      return this.$store.getters.productTypes
    },
    vehicles () {
      return this.$store.getters.vehicles
    },
    deviceIDs () {
      return this.devices.map(a => a.id)
    },
    filteredDeviceTypes () {
      return this.deviceTypes.filter(device => { return device.extras && device.extras.findIndex(extra => { return extra.type === 'uid' }) !== -1 })
    },
    filteredVehicles () {
      if (this.newDevice.customer) {
        return this.vehicles.filter(veh => {
          return this.newDevice.customer === veh.Customer
        })
      }
      return this.vehicles
    },
    filteredProducts () {
      if (this.selectedDeviceType) {
        return this.productTypes.filter(product => {
          return product.devices && product.devices.indexOf(this.selectedDeviceType.id) !== -1
        })
      }
      return []
    },
    filteredDevices () {
      this.devicesLoading = true
      let filteredDevices = []
      this.stockTotal = 0
      let devices = JSON.parse(JSON.stringify(this.devices))
      for (let device of devices) {
        if (this.deviceTypeFilter && this.deviceTypeFilter !== device.type) {
          continue
        }
        if (this.vehicleFilter.length > 0 && this.vehicleFilter.indexOf(device.vehicle) === -1) {
          continue
        }
        if (this.selectedCustomer.length > 0 && this.selectedCustomer.indexOf(device.customer) === -1) {
          continue
        }
        if (!device.SIM) {
          device.SIM = ''
        }
        if (device.type) {
          let type = this.deviceTypes.find(c => { return c.id === device.type })
          device.formattedType = type !== undefined ? type.name : ''
        } else {
          device.formattedType = ''
        }
        if (device.customer) {
          let customer = this.customers.find(c => { return c.key === device.customer })
          device.formattedCustomer = customer !== undefined ? customer.name : ''
        } else {
          device.formattedCustomer = ''
          this.stockTotal++
        }
        if (device.vehicle && this.vehicles) {
          let vehicle = this.vehicles.find(c => { return c.key === device.vehicle })
          device.formattedVehicle = vehicle !== undefined ? vehicle.VehicleReg : ''
        } else {
          device.formattedVehicle = ''
        }
        if (device.product) {
          let product = this.productTypes.find(c => { return c.id === device.product })
          device.formattedProduct = product !== undefined ? product.name : ''
        } else {
          device.formattedProduct = ''
        }
        filteredDevices.push(device)
      }
      this.devicesLoading = false
      return filteredDevices
    },
    SIMS () {
      return this.$store.getters.SIMS
    },
    // unallocatedSIMS () {
    //   return this.SIMS.filter(sim => {
    //     return this.devices.findIndex(device => { return device.SIM === sim.ICCID }) === -1
    //   }).map(a => a.ICCID)
    // }
    filteredSIMS () {
      return this.devices.map(a => a.SIM)
    }
  },
  methods: {
    columnValueList (val) {
      return this.calampTableDetails.map((d) => d[val.toString()])
    },
    gotoBulkSMS () {
      let ICCIDArray = []
      for (let item of this.selectedEsns) {
        ICCIDArray.push(item.iccid)
      }
      sessionStorage.setItem('ICCIDS', JSON.stringify(ICCIDArray))
      window.open('/#/BulkSMS')
    },
    updateSelectedCalamps () {
      this.updatingCalamps = true
      this.updateCalampAtPosition(0)
      this.updateCalampErrorMessages = []
      updateAuditLog('update', 'calamp', this.user, null, null, 'updated calamps', this.selectedEsns, null)
    },
    updateCalampAtPosition (position) {
      if (this.selectedEsns[position]) {
        if (this.updateCalampObj.updateConfig) {
          var requestOptions = {
            method: 'POST',
            redirect: 'follow',
            mode: 'cors',
            body: JSON.stringify({
              authToken: this.authToken,
              endpoint: `device-services/jobs`,
              /* eslint-disable */
              params: `{"job": {"progressStatus": "Pending","account": {"href": "${this.updateCalampObj.newConfig.account.href}"},"tasks": [{"task": {"metaData": {"file": "${this.updateCalampObj.newConfig._self.href}"}, "name": "task_0", "description": "Update config", "status": "Enabled", "taskType": "File", "deviceType": "LMU", "fileType": "Config", "deviceTypeId": "${this.updateCalampObj.newConfig.validationMetaData.deviceTypeId}", "fileTypeId": "${this.updateCalampObj.newConfig.validationMetaData.fileTypeId}", "fileName": "${this.updateCalampObj.newConfig.name}", "fileAction": "Overwrite"}}], "criteria": [{"smartSearch": {"queryString": "${this.selectedEsns[position].esn}", "type": "device", "accountId": 33442}}],"name": "${this.selectedEsns[position].esn} - ${moment().format('YYYYMMDDHHmm')}"}}`
              /* eslint-enable */
            }),
            headers: {
              'content-type': 'application/json; charset=UTF-8'
            }
          }

          fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result.errors) {
                this.updateCalampErrorMessages.push(this.selectedEsns[position].esn + ' - ' + result.errors)
              }
              if (!this.updateCalampObj.updateGroup) {
                position++
                setTimeout(() => {
                  this.updateCalampAtPosition(position)
                }, 100)
                console.log(result)
              }
            })
            .catch(error => console.log('error', error))
        }

        if (this.updateCalampObj.updateGroup) {
          setTimeout(() => {
            var requestOptions = {
              method: 'POST',
              redirect: 'follow',
              mode: 'cors',
              body: JSON.stringify({
                authToken: this.authToken,
                endpoint: `connect/services/groups/members?v=2.1`,
                /* eslint-disable */
                params: `{
                  "groupMembers": {
                    "members": [
                      {
                        "href": "${this.selectedEsns[position]._self.href}",
                        "rel": "device"
                      }
                    ]
                  }
                }`
                /* eslint-enable */
              }),
              headers: {
                'content-type': 'application/json; charset=UTF-8'
              }
            }

            fetch('https://cwelite.aquariusit.com/calampMiddleManDelete.php', requestOptions)
              .then(response => response.json())
              .then(result => {
                var requestOptions = {
                  method: 'POST',
                  redirect: 'follow',
                  mode: 'cors',
                  body: JSON.stringify({
                    authToken: this.authToken,
                    endpoint: `connect/services/groups/${this.updateCalampObj.newGroup.id}/members?v=2.1`,
                    /* eslint-disable */
                    params: `{
                      "groupMembers": {
                        "members": [
                          {
                            "href": "${this.selectedEsns[position]._self.href}",
                            "rel": "device"
                          }
                        ]
                      }
                    }`
                    /* eslint-enable */
                  }),
                  headers: {
                    'content-type': 'application/json; charset=UTF-8'
                  }
                }
                fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
                  .then(response => response.json())
                  .then(result => {
                    if (result.errors) {
                      result.message = result.errors
                    } else {
                      result.message = 'Successfully moved group'
                    }
                    this.updateCalampErrorMessages.push(this.selectedEsns[position].esn + ' - ' + result.message)
                    position++
                    setTimeout(() => {
                      this.updateCalampAtPosition(position)
                    }, 100)
                  })
                  .catch(error => console.log('error', error))
              })
              .catch(error => console.log('error', error))
          }, 100)
        }
      } else {
        if (this.updateCalampErrorMessages.length) {
          this.messagesDialog = true
        }
        this.updatingCalamps = false
        this.updateCalampDialog = false
        setTimeout(() => {
          this.lookupCalamp()
        }, 500)
      }
    },
    updateESN () {
      let concatESNs = this.inputESN.replace(/\s/g, '').replace(/;/g, '').replace(/,/g, '')
      if (this.useIMEI) {
        this.ESNarray = this.ESNarray.concat(concatESNs.match(/(.{1,15})/g)).filter((v, i, a) => a.indexOf(v) === i && !isNaN(v))
      } else {
        this.ESNarray = this.ESNarray.concat(concatESNs.match(/(.{1,10})/g)).filter((v, i, a) => a.indexOf(v) === i && !isNaN(v))
      }
      this.inputESN = ''
      this.bulk = false
    },
    lookupCalamp () {
      this.loadingDialog = true
      this.calampTableDetails = []
      this.calampErrorMessages = []
      this.confirmedESNArray = []
      this.getCalampAtPostion(0)
    },
    getCalampAtPostion (position) {
      if (this.ESNarray[position]) {
        var requestOptions = {
          method: 'POST',
          redirect: 'follow',
          mode: 'cors',
          body: JSON.stringify({
            'params': `{"search": { "queryString": "${this.ESNarray[position]}"}}`,
            'endpoint': `device-services/devices/smartsearch?include=groups&withIdReport=true&withCredentials=true&withLocation=true&expand=deviceConfiguration&v=2.1&pg=1&pgsize=10&sort=+name`,
            'authToken': this.authToken
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }

        fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.errors) {
              this.calampErrorMessages.push(this.ESNarray[position] + ' - ' + result.message)
            } else {
              result.response.results[0].device.configVersion = result.response.results[0].device.idReport.device.idReport.configVersion
              result.response.results[0].device.configStatus = null
              result.response.results[0].device.configGroup = null
              result.response.results[0].device.scriptVersion = result.response.results[0].device.idReport.device.idReport.scriptVersion + '.' + result.response.results[0].device.idReport.device.idReport.configVersion
              result.response.results[0].device.group = result.response.results[0].device.groups && result.response.results[0].device.groups.length ? result.response.results[0].device.groups[0].title : ''
              this.calampTableDetails.push(result.response.results[0].device)
              this.selectedEsns.push(result.response.results[0].device)
              this.confirmedESNArray.push(result.response.results[0].device.esn)
            }
            position++
            setTimeout(() => {
              this.getCalampAtPostion(position)
            }, 100)
          })
          .catch(error => console.log('error', error))
      } else {
        this.getCalampConfigsAtPosition(0)
        if (this.calampErrorMessages.length) {
          this.messagesDialog = true
        }
      }
    },
    getCalampConfigsAtPosition (position) {
      if (this.ESNarray[position]) {
        var requestOptions = {
          method: 'POST',
          redirect: 'follow',
          mode: 'cors',
          body: JSON.stringify({
            endpoint: `device-services/devices/${this.confirmedESNArray[position]}/filehistory/current`,
            authToken: this.authToken
          }),
          headers: {
            'content-type': 'application/json; charset=UTF-8'
          }
        }

        fetch('https://cwelite.aquariusit.com/calampMiddleManGet.php', requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.message) {
              this.calampErrorMessages.push(this.ESNarray[position] + ' - ' + result.message)
            } else {
              result[0] = result.reduce((prev, current) => (prev.lastUpdateTime > current.lastUpdateTime) ? prev : current)
              this.calampTableDetails[position].configGroup = result[0].newDeviceFile.version + ' ' + result[0].transactionStatus.name + ' ' + result[0].lastUpdateTime
              this.calampTableDetails[position].configStatus = result[0].transactionStatus.name
            }
            position++
            setTimeout(() => {
              this.getCalampConfigsAtPosition(position)
            }, 100)
          })
          .catch(error => console.log('error', error))
      } else {
        this.loadingDialog = false
        if (this.calampErrorMessages.length) {
          this.messagesDialog = true
        }
      }
    },
    initUpdateDialog () {
      this.calampGroups = []
      this.fetchGroups(1)

      setTimeout(() => {
        this.calampConfigs = []
        this.fetchConfigs(1)
      }, 100)
      this.updateCalampDialog = true
    },
    expandCalampDetails (props) {
      props.expanded = !props.expanded
      const clean = (object, i = 0) => {
        let returnArray = []
        for (let key in object) {
          i++
          let itemObj = {
            id: i
          }
          if (typeof object[key] !== 'object') {
            itemObj.name = key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => { return str.toUpperCase() }) + ': ' + object[key]
          } else {
            itemObj.name = key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => { return str.toUpperCase() })
            itemObj.children = clean(object[key], i * 100)
          }
          returnArray.push(itemObj)
        }
        return returnArray
      }
      this.activeCalampDetails = clean(props.item)
    },
    fetchGroups (page) {
      var requestOptions = {
        method: 'POST',
        redirect: 'follow',
        mode: 'cors',
        body: JSON.stringify({
          'params': `{"search": {"searchTerms": {"name": "**"},"maxResults": 999}}`,
          'endpoint': `connect/services/groups/search?v=2.1&pgsize=1000&pg=${page}`,
          'authToken': this.authToken
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }
      fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
        .then(response => response.json())
        .then(result => {
          for (let i of result.response.results) {
            this.calampGroups.unshift(i.group)
          }
          if (result.response._links[3]) {
            page++
            this.fetchGroups(page)
          }
        })
        .catch(error => console.log('error', error))
    },
    fetchConfigs (page) {
      var requestOptions = {
        method: 'POST',
        redirect: 'follow',
        mode: 'cors',
        body: JSON.stringify({
          endpoint: 'connect/services/files/search?pgsize=1000&pg=' + page,
          // eslint-disable-next-line
          params: `{"search": {"searchTerms": {"validationMetaData": "{\\"platformName\\": \\"LMU Config\\"}"}}}`,
          authToken: this.authToken
        }),
        headers: {
          'content-type': 'application/json; charset=UTF-8'
        }
      }
      fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
        .then(response => response.json())
        .then(result => {
          for (let i of result.response.results) {
            if (!i.filemeta.name.includes('migratedFromPuls')) {
              this.calampConfigs.push(i.filemeta)
            }
          }
          if (result.response._links[3]) {
            page++
            this.fetchConfigs(page)
          } else {
            this.calampConfigs.sort((a, b) => {
              return a.name > b.name ? 1 : -1
            })
          }
        })
        .catch(error => console.log('error', error))
    },
    openTesting (props) {
      this.testingDialog = true
      this.testsUID = props.id
      if (props.IMEI) {
        this.testType = 'IMEI'
        this.testID = props.IMEI
      } else {
        this.testType = 'DVRID'
        this.testID = props['DVR ID Number']
      }
    },
    getDeviceHistory (props) {
      props.expanded = !props.expanded
      this.installationJob = null
      this.loadingDeviceHistory = true
      fireStore.collection('Jobs').where('devicesInstalled', 'array-contains', props.item.id).get()
      .then(docRef => {
        docRef.forEach(doc => {
          let installationJob = doc.data()
          let contractTerm = installationJob.finance[props.item.type].contractTerm
          let completedDate = installationJob.CompletedDate
          installationJob.CompletedDate = moment(completedDate).format('DD/MM/YYYY')
          installationJob.contractDetails = {}
          if (contractTerm.indexOf('days') !== -1) {
            installationJob.contractDetails.period = 'days'
            installationJob.contractDetails.length = contractTerm.replace(/\D/g, '')
            installationJob.contractDetails.expiry = moment(completedDate).add(installationJob.contractDetails.length, installationJob.contractDetails.period).format('DD/MM/YYYY')
          } else if (contractTerm.indexOf('months') !== -1) {
            installationJob.contractDetails.period = 'months'
            installationJob.contractDetails.length = contractTerm.replace(/\D/g, '')
            installationJob.contractDetails.expiry = moment(completedDate).add(installationJob.contractDetails.length, installationJob.contractDetails.period).format('DD/MM/YYYY')
          } else {
            installationJob.contractDetails.period = ''
            installationJob.contractDetails.length = 'N/A'
            installationJob.contractDetails.expiry = 'N/A'
          }
          this.installationJob = installationJob
        })
        this.loadingDeviceHistory = false
      })
    },
    exportData () {
      let data = ''
      for (let column of this.deviceColumns) {
        data += column.text + '\t'
      }
      data += '\n'
      for (let device of this.filteredDevices) {
        for (let column of this.deviceColumns) {
          data += (device[column.value] || '') + '\t'
        }
        data += '\n'
      }
      document.getElementById('exportData').value = data
      document.getElementById('exportData').removeAttribute('hidden')
      setTimeout(() => {
        document.getElementById('exportData').select()
        document.execCommand('copy')
      }, 20)
      setTimeout(() => {
        document.getElementById('exportData').setAttribute('hidden', true)
        document.getElementById('exportData').value = ''
        this.exportAlert = true
      }, 40)
    },
    editDevice (item) {
      this.editID = item.id
      this.editSIM = item.SIM || -1
      this.selectedDeviceType = this.deviceTypes.find(device => { return device.id === item.type })
      this.newDevice = {...item}
      this.addDeviceDialog = true
    },
    createExportTemplate () {
      let finalString = ''
      for (let extra of this.selectedDeviceType.extras) {
        finalString += extra.name + '\t'
      }
      finalString += 'vehicle' + '\t'
      finalString += 'stockLocation'
      this.excelInput = finalString

      setTimeout(() => {
        document.getElementById('excelInput').select()
        document.execCommand('copy')
        this.exported = true
        this.excelInput = ''
      }, 20)
    },
    importFromTemplate () {
      let rows = []
      rows = this.excelInput.split('\n')
      let headers = rows.splice(0, 1)
      headers = headers[0].split('\t')
      let uidField = this.selectedDeviceType.extras.find(extra => {
        return extra.type === 'uid'
      }).name
      let uidIndex = headers.indexOf(uidField)
      let batch = fireStore.batch()
      let rowCount = 0
      for (let row of rows) {
        row = row.split('\t')
        if (row.length !== headers.length) {
          continue
        }
        rowCount++
        let rowObj = {}
        let uid
        for (let i = 0; i < row.length; i++) {
          const element = row[i]
          if (uidIndex === i) {
            uid = element
          }
          if (headers[i] === 'vehicle') {
            let vehicle = this.vehicles.find(veh => { return veh.VehicleReg === element })
            let vehReg = vehicle ? vehicle.key : null
            let customer = vehicle ? vehicle.Customer : null
            rowObj['vehicle'] = vehReg
            rowObj['customer'] = customer
          } else if (headers[i] === 'SIM') {
            if (element.length < 19) {
              rowObj[headers[i]] = ''
            } else {
              rowObj[headers[i]] = element
            }
          } else {
            rowObj[headers[i]] = element
          }
        }
        rowObj.product = this.exportProduct
        rowObj.type = this.selectedDeviceType.id
        console.log(rowObj)
        batch.set(fireStore.collection('Devices').doc(uid), rowObj, { merge: true })
        if (rowCount === 499) {
          break
        }
      }
      batch.commit().then(() => {
        this.bulkAddDeviceDialog = false
      })
    },
    newDeviceDialog () {
      this.editID = -1
      this.editSIM = -1
      this.selectedDeviceType = {}
      this.addDeviceDialog = true
    },
    addDevice () {
      this.adding = true
      let uidField = this.selectedDeviceType.extras.find(extra => {
        return extra.type === 'uid'
      }).name

      for (let element in this.newDevice) {
        if (this.newDevice[element] === undefined || (element === 'SIM' && this.newDevice[element].length < 19)) {
          this.newDevice[element] = null
        }
      }

      if (this.newDevice[uidField].length) {
        delete this.newDevice['formattedType']
        delete this.newDevice['formattedCustomer']
        delete this.newDevice['formattedVehicle']
        delete this.newDevice['formattedProduct']
        fireStore.collection('Devices').doc(this.newDevice[uidField]).set(this.newDevice, {merge: true})
          .then(() => {
            this.adding = false
            this.addDeviceDialog = false
          })
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// Devices.vue?0d43d0ca